export function deleteCookies() {
  try {
    const allCookies = document.cookie.split(";");
    for (let i = 0; i < allCookies.length; i++) {
      const split = allCookies[i].split("=");
      const name = split[0].trim();
      if (name !== "auth") {
        console.log("Skipping", name, "cookie");
        continue;
      }
      const fake = split[0] + "=clear"; // safer cookie
      const newc = fake + ";expires=" + new Date(0).toUTCString();
      // to be sure we remove all versions of the cookie we set these 2 variants
      document.cookie = newc;
      document.cookie = newc + ` ;Domain=.${document.location.host}`;
    }
    if (document.cookie.includes("auth=")) {
      console.error("Could not clean auth cookie");
    }
  } catch (e) {
    console.error("Cookie cleaning error", e);
  }
}
